import SearchInvoicesVadIvend from './SearchInvoicesVadIvend'

export default SearchInvoicesVadIvend
